import {Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {MatSnackBar} from '@angular/material'
import {ConfService} from '../../conf.service';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {LeftpanelNewComponent} from '../../leftpanel-new/leftpanel-new.component';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {interval} from 'rxjs';
import {AddS3ConnectorsConfigNewComponent} from './add-s3-connectors-config-new/add-s3-connectors-config-new.component';
import {Router} from "@angular/router";
@Component({
  selector: 'app-s3-connectors-new',
  templateUrl: './s3-connectors-new.component.html',
  styleUrls: ['./s3-connectors-new.component.scss']
})
export class S3ConnectorsNewComponent implements OnInit {
  componentData: any;
  totalServices: any;
  settingsData: any;
  environment: any;
  selectedEnvironment: any;

  selectedElement: any;
  dataSource: any;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  componentLoading = true;
  originalData:any



  displayedColumns: string[] = [
    'default',
    'name',
    'provider',
    'bucketName',
    'actions',
  ];

  constructor(
      public platform: LeftpanelNewComponent,
      private snackBar: MatSnackBar,
      private dialog: MatDialog,
      private confPost: ConfService,
      private adminEnvironmenthandler: AdminEnvironmentHandlerService,
      private partnerSettingsService: PartnerSettingsService,
      public router: Router
  ) { }

  // Functionality  

  editToggle(i) {
    this.originalData = { ...this.dataSource['data'][i] };
    this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
  }



  cancelEdit(i: number) {
    this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
    this.dataSource['data'][i] = { ...this.originalData }
  }

  editConfiguration(i) {
    if (this.totalServices) {
      this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }
      const temp = this.totalServices.filter((service) => service.name === 'S3 Bucket Connectors');
      if (temp && temp.length > 0) {
        temp[0]['configurations'][i] = this.dataSource['data'][i];
      }
      this.componentData['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['env']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services',
          'services',
          'v2',
          'settings',
          this.settingsData['id'],
          this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration updated successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize('S3BucketConnectors');
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while updating configuration.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  removeConfiguration(i) {
    if (this.totalServices) {
      const temp = this.totalServices.filter((service) => service.name === 'S3 Bucket Connectors');
      if (temp && temp.length > 0) {
        if (temp[0]['configurations'][i]['is_default'] !== true) {
          if (confirm('This action is irreversible. Are you sure want to remove this configuration?')) {
            for (const val of this.dataSource.data) {
              delete val['isEdit'];
            }
            temp[0]['configurations'].splice(i, 1);
            this.componentData['configurations'] = temp[0]['configurations'];
            const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
            if (temp1 && temp1.length > 0) {
              temp1[0]['services'] = this.totalServices;
            }

            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
              width: 'auto',
              height: 'auto',
            });

            this.confPost.patchEntityData('services',
                'services',
                'v2',
                'settings',
                this.settingsData['id'],
                this.settingsData).subscribe(resp => {
              if (resp) {
                this.snackBar.open( 'Configuration deleted successfully', 'Success', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.initialize('S3BucketConnectors');
              }
              loaderDialog.close();
            }, error => {
              this.snackBar.open( 'Error while deleting the configuration.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
            });
          }
        } else {
          this.snackBar.open('Default configuration cannot be deleted.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    }
  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  changeDefault(event, index) {
    const temp = this.totalServices.filter((service) => service.name === 'S3 Bucket Connectors');
    if (temp && temp.length > 0) {
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }

      for (const config of temp[0]['configurations']) {
        config['is_default'] = false;
      }

      temp[0]['configurations'][index]['is_default'] = true;

      this.componentData['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }

      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services',
          'services',
          'v2',
          'settings',
          this.settingsData['id'],
          this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration made default successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize('S3BucketConnectors');
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while making the configuration default', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  addConfiguration() {
    const addConfigurationDialog = this.dialog.open(AddS3ConnectorsConfigNewComponent, {
      width: '60vw',
      height: 'auto',
      panelClass: 'dialog-color',
      data: {
        configuration: {
          regions: [],
          name: '',
          url: '',
          status: '',
          is_default: false,
          cloud: '',
          primary_region: '',
          verification_status: 'created',
          audit_logs: [
            {
              action: 'CREATE',
              by: localStorage.getItem('primary_email'),
              at: Date.now()
            }
          ],
        },
        isEdit: false
      }
    });

    addConfigurationDialog.afterClosed().subscribe(response => {
      if (response) {
       if (this.totalServices) {
          for (const val of this.dataSource.data) {
             delete val['isEdit'];
          }
          const temp = this.totalServices.filter((service) => service.name === 'S3 Bucket Connectors');
          if (temp && temp.length > 0) {
            temp[0]['configurations'].push(response);
          }
          this.componentData['configurations'] = temp[0]['configurations'];
          const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['env']);
          if (temp1 && temp1.length > 0) {
            temp1[0]['services'] = this.totalServices;
          }

          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
          });

          this.confPost.patchEntityData('services',
              'services',
              'v2',
              'settings',
              this.settingsData['id'],
              this.settingsData).subscribe(resp => {
            if (resp) {
              this.snackBar.open( 'Configuration added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.initialize('S3BucketConnectors');
            }
            loaderDialog.close();
          }, error => {
            this.snackBar.open( 'Error while adding the configuration.', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            loaderDialog.close();
          });
        }
      }
    });
  }

  getId(id) {
    const str = id.split(' ').join('');
    return str;
  }

  getData(componentKey) {
    this.settingsData = this.partnerSettingsService.settingsData;
    this.totalServices = this.partnerSettingsService.environmentServices;
    this.environment = this.partnerSettingsService.environment;
    this.componentData = this.environment.services.find(service => this.getId(service['name']) === componentKey);
    this.selectedEnvironment = this.adminEnvironmenthandler.currentEnvironment;
   if (this.componentData) {
      this.dataSource = new MatTableDataSource([]);
      for (const val of this.componentData['configurations']) {
        val['isEdit'] = false;
        if (val.is_default === true) {
          this.selectedElement = val;
        }
      }
      this.dataSource.data = this.componentData['configurations'];
    } else {
      console.log('error');
    }
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  initialize(componentKey: any) {

    const refreshTwice = async () => {
      this.getData(componentKey);

      // Check if data length is 0 and refresh again
      if (this.dataSource.data && this.dataSource.data.length === 0) {
        this.getData(componentKey);
      }
    };

    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        this.getData(componentKey);
        let environmentData = this.adminEnvironmenthandler.currentEnvironment;
        if (environmentData.env.includes('admin-')) {
          this.redirect('/console');
        } else {
          refreshTwice();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          this.getData(componentKey);
          environmentData = this.adminEnvironmenthandler.currentEnvironment;
          if (environmentData.env.includes('admin-')) {
            this.redirect('/console');
          } else {
            refreshTwice();
          }
        });
        this.componentLoading = false;
      } else {
        this.componentLoading = true;
      }
    }));
  }

  refreshPage(){
    this.getData('S3BucketConnectors');
  }

  ngOnInit() {
    this.initialize('S3BucketConnectors');
  }}
